import React from 'react';
import { scrollTop } from 'utils/wrappers';
import { formatIsoDateUnix } from 'utils/dates';

import FulfillmentBOLs from 'app/collections/fulfillment_bols';
import Paginator from 'app/models/paginator';
import DateRange, { DATERANGE_PARAM_TYPES } from 'app/models/date_range';

import Base from 'app/views/base';
import DatepickerRangeView from 'app/views/datepicker_range_view';
import PaginationView from 'app/views/pagination_view';
import SelectorView from 'app/views/selector_view';
import BOLCreateView from 'app/components/pages/fulfillment_bols/create';

import { List as ListView, Heading } from 'app/components/list/list';
import ListSearchView from 'app/components/list/search';
import PageHeader from 'app/components/page_header_react';
import ApiModeSelection from 'app/models/api_mode_selection';

import tmpl from './template';
import DetailsView from './details';

const PAGE_SIZE = 10;
export const MIN_DATERANGE_DATE = '2017-09-20';

export default Base.extend({
  compiledTemplate: tmpl,
  className: 'fulfillment_bols',

  initialize() {
    this.apiModeSelection = new ApiModeSelection({});
    this.dateRange = new DateRange({ paramType: DATERANGE_PARAM_TYPES.DATETIME });

    this.collection = new FulfillmentBOLs([], {
      dateRange: this.dateRange,
      apiModeSelection: this.apiModeSelection,
    });

    this.paginator = new Paginator({
      collection: this.collection,
      pageSize: PAGE_SIZE,
      buildParams() {
        return {
          limit: PAGE_SIZE,
          page: this.get('currentPage'),
          offset: this.get('currentPage') * PAGE_SIZE,
        };
      },
    });

    this.listenTo(this.collection, 'sync', scrollTop);
    this.listenTo(this.collection, 'update', this.render);

    const headings = [
      new Heading({
        text: m => (m.get('id') ? ({ copy: true, text: m.get('id') }) : null),
        display: 'BOL ID',
        xsSize: 5,
        smSize: 5,
        mdSize: 2,
      }),
      new Heading({
        text: m => formatIsoDateUnix(m.get('created_at')),
        display: 'Created Date',
        mdSize: 2,
        smHidden: true,
      }),
      new Heading({
        text: m => (
          m.last_item_received_at() ? formatIsoDateUnix(m.last_item_received_at()) : null
        ),
        display: 'Last Item Received At',
        xsSize: 5,
        smSize: 3,
        mdSize: 2,
      }),
      new Heading({
        text: m => m.get('line_items').reduce((sum, item) => sum + item.units, 0),
        display: 'Total Qty.',
        xsSize: 2,
        smSize: 2,
        mdSize: 1,
      }),
      new Heading({
        text: m => m.get('line_items').reduce((sum, item) => sum + item.received_units, 0),
        display: 'Rcvd.',
        smSize: 2,
        mdSize: 1,
        xsHidden: true,
      }),
      new Heading({
        text: m => (m.get('tracking_code') ? ({ copy: true, text: m.get('tracking_code') }) : null),
        display: 'Tracking Code',
        mdSize: 2,
        smHidden: true,
      }),
    ];

    this.addReactComponent('header', <PageHeader name="Fulfillment BOLs" />);
    this.addSubview('bolList', '#bol_list', new ListView({
      headings,
      collection: this.collection,
      user: this.user,
      noResultsMessage: 'No BOLs found matching your filter set.',
      showDetails: {
        mainHeading: 'Products',
        DetailsView,
      },
    }));

    this.addSubview('pagination', '#bol_pagination', new PaginationView({ model: this.paginator }));
    this.addSubview('apiModeSelector', '#api_mode_selector', new SelectorView({ model: this.apiModeSelection }));
    this.addSubview('datepickers', '#bol_daterange_pickers', new DatepickerRangeView({ model: this.dateRange, minDate: MIN_DATERANGE_DATE }));
    // we're only going to allow production BOLs to be created from the dashboard
    this.addSubview('createBOL', '#create_bol', new BOLCreateView({ apiModeSelection: new ApiModeSelection({ mode: 'production' }), collection: this.collection }));

    this.addSubview('search', '#bol_search', new ListSearchView({
      collection: this.collection,
      placeholder: '(BOL ID, Warehouse ID, Tracking Code, Product Barcode)',
      apiModeSelection: this.apiModeSelection,
    }));

    this.getSubview('createBOL').on('create:success', BOL => {
      this.collection.add(BOL);
    });
  },
});



// WEBPACK FOOTER //
// ./app/components/pages/fulfillment_bols/index.jsx